/**
 * Backend стримит сообщения support-чата как Telegram-flavored HTML
 * (тег-allowlist: b, i, u, s, code, pre, br, a). Часть бэкендов отдаёт
 * теги уже сырыми (`<b>...</b>`), часть — entity-escaped (`&lt;b&gt;...&lt;/b&gt;`).
 * Эта функция декодирует допустимые entity-escaped теги и заменяет переводы
 * строк на `<br />`, чтобы результат можно было передать в `dangerouslySetInnerHTML`.
 *
 * Парная функция в PWA: `pages/Wiki.tsx` — поведение идентично, чтобы
 * админ и клиент видели одинаковое форматирование.
 */
export function normalizeSupportHtml(html: string): string {
  let out = String(html ?? '');

  out = out.replace(/\r\n/g, '\n').replace(/\n/g, '<br />');

  const allowedSimple = ['b', 'i', 'u', 's', 'code', 'pre', 'br'];
  for (const tag of allowedSimple) {
    out = out.replace(new RegExp(`&lt;/?${tag}\\s*/?&gt;`, 'gi'), (m) =>
      m.toLowerCase().startsWith('&lt;/') ? `</${tag}>` : (tag === 'br' ? '<br />' : `<${tag}>`)
    );
  }

  out = out.replace(/&lt;a href=&quot;([^&]*)&quot;&gt;/gi, '<a href="$1">');
  out = out.replace(/&lt;a href=\"([^\"]*)\"&gt;/gi, '<a href="$1">');
  out = out.replace(/&lt;\/a&gt;/gi, '</a>');

  return out;
}
